// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1S_Q3","notes":"Notes_notes__pbKMn","note":"Notes_note__2cMp8","markdown":"Notes_markdown__2wNFY"};